var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_Layer_",
    "data-name": "<Layer>",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.72,16.87,21,16.4c.05-.12.11-.23.16-.35a4.07,4.07,0,0,0,.18-.44c.06-.14.11-.28.16-.42s.09-.28.13-.43.09-.32.13-.49.06-.26.08-.39.07-.4.09-.6,0-.22.05-.33c0-.31,0-.62,0-.94h0A10,10,0,0,0,12,2h0a10.07,10.07,0,0,0-3,.45c-.31.1-.62.21-.92.34A10.08,10.08,0,0,0,4.29,5.65,10.28,10.28,0,0,0,3.22,7.24,10,10,0,0,0,2,12c0,.32,0,.64.05,1,0,.11,0,.21,0,.31s.06.42.1.63,0,.24.08.36.09.36.14.54l.12.37c0,.17.12.34.18.5l.15.37c.07.16.15.32.23.48l.18.34c.09.16.19.32.29.48l.19.29a7,7,0,0,0,.52.7h0A10,10,0,0,0,20.6,17.05ZM12,4A3.94,3.94,0,1,1,8,8,3.94,3.94,0,0,1,12,4ZM12,20.3a7,7,0,0,1-6-3.44,6.92,6.92,0,0,1,12.06-.06A7,7,0,0,1,12,20.3Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.0f73a7af597547945c5ca6d9c07c718f.svg";
export { ForwardRef as ReactComponent };